var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { PaginationState, Paginator } from "../../../../Components/UI";
import { useLocation, useSearchParams } from 'react-router';

const PXTableFooter = ({
  totalPages = 0,
  total = 0,
  currentDataLength = 0




}) => {
  const location = useLocation();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();

  return (/*#__PURE__*/
    _jsx("div", { className: "flex justify-between h-6 items-center" }, void 0, /*#__PURE__*/
    _jsx(PaginationState, {
      page: Number(searchParams.get('page') || 1),
      size: 10,
      total: total || totalPages * 10,
      currentLength: currentDataLength }
    ), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(Paginator, {
      totalPages: totalPages,
      currentPage: searchParams.has('page') ? Number(searchParams.get('page')) : 1,
      buildUrl: (page) => {
        const innerSearchParams = new URLSearchParams(location.search);
        innerSearchParams.delete('page');
        innerSearchParams.set('page', page);
        return `${location.pathname}?${innerSearchParams.toString()}`;
      } }
    )
    )
    ));

};

export { PXTableFooter };